import { useEffect, useState } from 'react';
import { resolveHostApi } from '../api/applicationType.api';

/**
 * Resolve vanity Host → packageId for citizen advisor bootstrap.
 * Apex / unmatched → packageId null (caller keeps SF marketing demo default).
 */
export default function useResolvedJurisdiction({ fallbackPackageId = null } = {}) {
  const [state, setState] = useState({
    loading: true,
    matched: false,
    platformApex: true,
    packageId: fallbackPackageId,
    hostBinding: null,
  });

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const host = typeof window !== 'undefined' ? window.location.host : '';
        const data = await resolveHostApi(host);
        if (cancelled) return;
        if (data?.matched && data.packageId) {
          setState({
            loading: false,
            matched: true,
            platformApex: false,
            packageId: data.packageId,
            hostBinding: data,
          });
        } else {
          setState({
            loading: false,
            matched: false,
            platformApex: Boolean(data?.platformApex),
            packageId: fallbackPackageId,
            hostBinding: data,
          });
        }
      } catch (_) {
        if (!cancelled) {
          setState({
            loading: false,
            matched: false,
            platformApex: true,
            packageId: fallbackPackageId,
            hostBinding: null,
          });
        }
      }
    })();
    return () => { cancelled = true; };
  }, [fallbackPackageId]);

  return state;
}
